const key = (userId, examId) =>
  `proctor_syschk_${String(userId)}_${String(examId)}`;

/**
 * Record a successful system check (from ProctoringWidget onSystemCheckComplete).
 * @param {string|number} userId
 * @param {string|number} examId
 */
export function recordProctoringSystemCheck(userId, examId) {
  try {
    const payload = JSON.stringify({ at: Date.now() });
    window.localStorage.setItem(key(userId, examId), payload);
  } catch (_) {}
}

/**
 * True if a check was recorded on or before the deadline timestamp.
 * @param {string|number} userId
 * @param {string|number} examId
 * @param {number} deadlineMs
 */
export function hasProctoringCheckBefore(userId, examId, deadlineMs) {
  try {
    const raw = window.localStorage.getItem(key(userId, examId));
    if (!raw) return false;
    const data = JSON.parse(raw);
    const at = data && typeof data.at === 'number' ? data.at : NaN;
    if (!Number.isFinite(at)) return false;
    return at <= deadlineMs;
  } catch (_) {
    return false;
  }
}
